import type { Configuration } from "../config";
import { defaults } from "./defaults";

const configuration: Configuration = {
  ...defaults,
  shop: {
    instance: "CH",
    countries: ["CH"],
    url: "https://www.alpinewhite.com",
    lang: { main: "de", enabled: ["de", "fr", "en"] },
    stamped: {
      apiKeyPublic: "pubkey-Yd39IppEMY1d2453YBo66HmL04y642",
      storeUrl: "shop.alpinewhite.ch",
    },
    sections: {
      shop: true,
      treatments: true,
    },
    partners: [
      "CH_BENU",
      "AT_BIPA",
      "CH_Coop",
      "CH_CoopVitality",
      "DACH_Douglas",
      "DACH_Flaconi",
      "CH_Galaxus",
      "CH_HaarShop",
      "DACH_LYKO",
      "CH_Manor",
      "CH_PerfectHair",
      "DE_Rossmann",
      "CH_Rotpunkt",
      "CH_ZurRose",
      "AT_DM",
      "DACH_ShopApotheke",
      "PL_SuperPharm",
      "DACH_Zalando",
    ],
    newsletter: true,
    scripts: {
      gtm: "GTM-P3K8685",
      getklar: "3252173022",
      facebook: "2531602960492053",
      tiktok: "D3615GBC77U729IS6O30",
      kameeleon: "fd1jnfk7ic",
      pinterest: "2613981124848",
      klaviyo: "MQgYCZ",
      skimLinks: "243839X1727274",
    },
    shopifyClient: {
      domain: "shop.alpinewhite.com",
      accessToken: "3e39457639afc56a46462c94f67b7a4f",
      shopId: "gid://shopify/Shop/25082855486",
      storefrontId: "1000094196",
    },
    meta: {
      de: {
        title: "Alpine White | Teeth Whitening Strips | Whitestrips | Bleaching ",
        description:
          "Selbst für ein strahlendes Lächeln sorgen. Alpine White bietet ein komplettes Set für Reinigung, Bleaching und Pflege. Entdecke unsere Whitening Strips.",
        keywords: [
          "Whitening Strips",
          "Whitestrips",
          "Bleaching",
          "Homebleaching",
          "Whitening Kit",
          "Zahnpflege",
          "Weisse Zähne",
          "Whitening Foam",
          "Charcoal Powder",
        ],
      },
      en: {
        title: "Alpine White | Teeth Whitening Strips | Whitestrips | Bleaching",
        description:
          "Give yourself a radiant smile with white teeth. Alpine White provides a complete kit for cleaning, bleaching and care. Discover our Whitening Strips.",
        keywords: [
          "Whitening Strips",
          "Whitestrips",
          "Bleaching",
          "Homebleaching",
          "Whitening Kit",
          "Dental Care",
          "White Teeth",
          "Charcoal Powder",
          "Whitening Foam",
        ],
      },
      fr: {
        title: "Alpine White | Strips Blanchiment Dentaire | Blanchiment",
        description:
          "Retrouvez un sourire rayonnant et des dents blanches. Alpine White propose une série de produits pour le nettoyage, le blanchiment et le soin des dents.",
        keywords: [
          "Kit Blanchiment Dentaire",
          "Blanchiment",
          "Bandes Blanchissantes",
          "Whitening Strips",
          "Whitestrips",
          "Soin Dentaire",
          "Charcoal Powder",
          "Whitening Foam",
        ],
      },
    },
  },
};

export { configuration };
